import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { format } from 'date-fns';

interface StartDateFilter {
  isDisabled?: boolean;
  onChange: (type: any, value: any) => void;
}
export const StartDateFilter = ({ isDisabled, onChange }: StartDateFilter) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker disabled={isDisabled}
        onChange={(date: any) => onChange("fromDate", format(new Date(date), 'MM/dd/yyyy'))}
        slotProps={{ textField: { size: 'small', label: `Start Date` } }}
        sx={{ width: '100%' }}
      />
    </LocalizationProvider>
  )
}